module.exports = __webpack_public_path__ + "media/images/map-icons/icon2_selected-e119ed83b4bae5fd8049642106a88e7a.png";